var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('Navbar'),_c('AppMain',{ref:"appMain"}),(_vm.tabbarShow)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }